import { Target } from "@org-avp/avp-avengers-tmm-service-api";
import { useCallback, useMemo } from "react";
import { tmmApi } from "../apis/tmm-service-api";
import { createCachedLookup } from "../utils/lookup.utils";

export interface TargetHelper {
  targetData: {
    data?: Target[];
    isLoading: boolean;
    error?: unknown;
  };

  createTargetLookup(): Map<string, Target>;
}

export const useTargetHelper = (colorFamilyEnabled: boolean): TargetHelper => {
  const targetData = tmmApi.useGetAllTargetsQuery(colorFamilyEnabled);

  const createTargetLookup = useCallback(
    () => cacheTargetLookup(targetData.data),
    [targetData.data],
  );

  return useMemo(
    () => ({ targetData, createTargetLookup }),
    [createTargetLookup, targetData],
  );
};

const targetLookupCache = new WeakMap<Target[], Map<string, Target>>();
const cacheTargetLookup = (targets: Target[] | undefined) => {
  return createCachedLookup(
    targetLookupCache,
    targets,
    (it) => it,
    (it) => it.targetId,
  );
};
